'use client';

import { configureStore } from '@reduxjs/toolkit';
import customerReducer from './features/customerSlice';
import subscriptionReducer from './features/subscriptionSlice';
import amandemenReducer from './features/amandemenSlice';
import dashboardReducer from './features/dashboardSlice';
import serviceRequestReducer from './features/serviceRequestSlice';

export const store = configureStore({
	reducer: {
		customerReducer: customerReducer,
		subscriptionReducer: subscriptionReducer,
		amandemenReducer: amandemenReducer,
		dashboardReducer: dashboardReducer,
		serviceRequestReducer: serviceRequestReducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
